module.exports = __webpack_public_path__ + "img/699.d6c17ddb.png";